import { SamwinUserShortInfoRemoteDto } from 'src/generated/signalR/samwin-user-short-info-remote-dto';

export class UserConfigurationChanged {
   public static readonly type = '[Samwin User Configuration] user configuration changed';

   constructor(public users: SamwinUserShortInfoRemoteDto[]) {}
}
